import { Sparkles } from "lucide-react"

const VerifiedEventCheck = ({ className = "" }) => {
    return (
        <div
            className={`flex items-center gap-1 bg-gradient-to-r from-emerald-400 to-teal-400 text-white px-3 py-1 rounded-full text-sm font-medium ${className}`}
        >
            <Sparkles className="h-4 w-4" />
            Verified
        </div>
    );
};
export default VerifiedEventCheck;